<template>
  <div>
    <!--    http://sagalbot.github.io/vue-select/-->
            <v-select id="listDemande" tabindex="-1"
                      :options="dataList"
                      placeholder="Veuillez choisir une demande ..."
                      label="label"
                      :value="dataSelected"
                      :onChange="changeSelected">
            </v-select>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {demandePoDP} from './demandePoDP'
  import {getLog} from './config'

  const log = getLog('goelandSelectPODPDemande', 4, 1)

  export default {
    name: 'goSelectPodpDemande',
    components: {
      vSelect
    },
    props: {
      value: {
        type: Object
      }
    },
    data: function () {
      return {
        dataSelected: null,
        dataName: '',
        test: null,
        dataList: []
      }
    }, // end of data section
    computed: {
    }, // end of computed props section
    watch: {
      value (val) {
        this.dataSelected = val
      }
    }, // end of watch props section
    created: function () {
      log.l('## IN goSelectPodpDemande created ')
    },
    mounted: function () {
      log.l('## IN goSelectPodpDemande mounted ', this.dataList.length)
      if (this.dataList.length < 1) {
        setTimeout(() => {
          log.l('## IN goSelectPodpDemande mounted SetTimeout')
          // TODO tester quand il n'y a pas de demandes
          demandePoDP.getListDemandes((data) => {
            log.l('## INSIDE  goSelectPodpDemande mounted callback for getListDemandes', data)
            this.dataList = data
          })
        }, 1000)
      }
      this.dataSelected = this.value
    }, // end of computed props section

    methods: {
      changeSelected (val) {
        this.$emit('input', val)
        this.$emit('newguid', val)
        log.l('## INSIDE  goSelectPodpDemande changeSelected ', val.value)
      }
    } // end of methods section
  }
</script>


<style lang="scss">
  @import '../styles/imports';
  @media (max-width: 600px) {
    .v-select input[type=search] {
      width: 500px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/goSelectPodpDemande.vue